/** Customer-friendly order status for account and receipts. */
export function orderStatusLabel(status) {
  const s = String(status || '')
    .trim()
    .toLowerCase()
    .replace(/_/g, ' ');

  switch (s) {
    case 'paid':
      return { label: 'Paid', className: 'account-order-status account-order-status--paid' };
    case 'processing':
      return { label: 'Processing', className: 'account-order-status account-order-status--paid' };
    case 'partially shipped':
    case 'partially_shipped':
      return {
        label: 'Part shipped',
        className: 'account-order-status account-order-status--paid',
      };
    case 'shipped':
      return { label: 'Shipped', className: 'account-order-status account-order-status--paid' };
    case 'completed':
      return { label: 'Delivered', className: 'account-order-status account-order-status--paid' };
    case 'cancelled':
    case 'canceled':
      return { label: 'Cancelled', className: 'account-order-status account-order-status--cancelled' };
    case 'pending':
    default:
      return { label: 'Placed — payment pending', className: 'account-order-status account-order-status--pending' };
  }
}

function isCancelledStatus(status) {
  const s = String(status || '')
    .trim()
    .toLowerCase();
  return s === 'cancelled' || s === 'canceled';
}

/** Status badge for order list cards (includes cancellation-requested before admin confirms). */
export function orderStatusDisplay(order) {
  const status = order?.status;
  if (order?.paid_at || String(order?.razorpay_payment_id || '').trim()) {
    const s = String(status || '').toLowerCase();
    if (s === 'pending') {
      return { label: 'Paid', className: 'account-order-status account-order-status--paid' };
    }
  }
  if (isCancelledStatus(status)) {
    return orderStatusLabel(status);
  }
  if (
    order?.cancel_requested_at &&
    !['shipped', 'completed', 'cancelled', 'canceled'].includes(String(status || '').toLowerCase())
  ) {
    return {
      label: 'Cancellation requested',
      className: 'account-order-status account-order-status--cancel-pending',
    };
  }
  return orderStatusLabel(status);
}

export function isOrderCancelled(order) {
  return isCancelledStatus(order?.status);
}
